export default __webpack_public_path__ + "static/media/logo-menu.0d7638ba.png";